/** Faixa "primeira vez?" que leva ao Guia de conexão no caminho certo. */
import React from "react";
import { Link } from "react-router-dom";

import "./guia.css";

export const GUIA = "/configuracoes/conectar";

export default function AtalhoDoGuia({ caminho, texto }) {
  return (
    <div className="gc-atalho">
      <span>{texto}</span>
      <Link to={caminho ? `${GUIA}?caminho=${caminho}` : GUIA}>Abrir o guia passo a passo</Link>
    </div>
  );
}
